import { IOption } from "@/types/global"
import { IParameter } from "../../parameters.types"


const fieldTypeOptions: IOption<IParameter['dataType']>[] = [
    { title: 'Float', value: 'FLOAT' },
    { title: 'Int16', value: 'INT16' },
    { title: 'Int32', value: 'INT32' },
    { title: 'Int64', value: 'INT64' },
    { title: 'Boolean', value: 'BOOLEAN' },
]

const parameterDataTypeDropdownStatusConstants = { fieldTypeOptions }
export default parameterDataTypeDropdownStatusConstants
